import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import {
	initialCompanyOutlet,
	initialCompanyOutletState,
} from "./defaultState";
import {
	FETCH_COMPANY_OUTLET_LIST_PROGRESS,
	FETCH_COMPANY_OUTLET_LIST_SUCCESS,
	FETCH_COMPANY_OUTLET_LIST_FAILED,
	FETCH_COMPANY_OUTLET_PROGRESS,
	FETCH_COMPANY_OUTLET_SUCCESS,
	FETCH_COMPANY_OUTLET_FAILED,
	CLEAR_COMPANY_OUTLET_STATE,
} from "./companyOutletActions";
import { error_message } from "../../constants/constants";

export const companyOutletReducer = (
	state: IStoreState["companyOutlet"] = initialCompanyOutletState,
	action: any
) => {
	switch (action.type) {
		// List Actions
		case FETCH_COMPANY_OUTLET_LIST_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.list.loading = LoadState.NotLoaded;
				draftState.list.list = [];
				draftState.list.totalRecords = 0;
			});
		}

		case FETCH_COMPANY_OUTLET_LIST_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.list.loading = LoadState.Loaded;
				draftState.list.list = data;
				draftState.list.error = null;
			});
		}

		case FETCH_COMPANY_OUTLET_LIST_FAILED: {
			const { errorMessage } = action.payload;
			return produce(state, (draftState) => {
				draftState.list.loading = LoadState.Failed;
				draftState.list.error = errorMessage;
			});
		}

		// Single Company Outlet Actions
		case FETCH_COMPANY_OUTLET_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.companyOutlet.loading = LoadState.InProgress;
				draftState.companyOutlet.data = initialCompanyOutlet;
			});
		}

		case FETCH_COMPANY_OUTLET_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.companyOutlet.loading = LoadState.Loaded;
				draftState.companyOutlet.data = data;
				draftState.companyOutlet.error = null;
			});
		}

		case FETCH_COMPANY_OUTLET_FAILED: {
			return produce(state, (draftState) => {
				draftState.companyOutlet.loading = LoadState.Failed;
			});
		}

		case CLEAR_COMPANY_OUTLET_STATE: {
			return produce(state, (draftState) => {
				draftState.companyOutlet.data = initialCompanyOutlet;
			});
		}

		default: {
			return state;
		}
	}
};
